import { useTranslation } from "react-i18next";
import { AlertCircle } from "@untitled-ui/icons-react";

import styles from "./RankCardWidget.module.scss";

const RankCardError = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <div className={`${styles.card} ${styles.errorCard}`}>
        <AlertCircle className={styles.errorIcon} width="16" height="16" />
        <span className={styles.errorText}>{t("emptyState.globalWrong")}</span>
      </div>
    </div>
  );
};

export default RankCardError;
